/*
---
covers:
  - frontend/src/pages/empresa/identidad/registro-empresa.tsx
  - frontend/src/pages/empresa/identidad/registro.tsx
  - frontend/src/components/registro-shell.tsx
  - frontend/src/components/ciiu-risk-picker.tsx
  - frontend/src/hooks/empresa/identidad/use-registro.ts
  - backend/app/empresa/identidad/routers/registro.py
  - backend/app/empresa/organizacion/routers/businesses.py
revisado: 2026-09-28
---
*/
import type {ManualSeccion} from '../types'

export const seccion: ManualSeccion = {
  id: 'crear-tu-empresa',
  titulo: 'Crear tu empresa',
  resumen:
    'El registro público de autoservicio en «Cree su empresa en Kairos» (/registro/empresa): datos de la empresa, representante legal y quién manejará el SG-SST — sin que nadie del equipo Kairos tenga que crearla por ti.',
  enCorto: [
    'Registro público de una empresa nueva',
    'Cargue datos, representante legal y responsable SG-SST',
    'Ya registrado: entre por Iniciar sesión',
  ],
  replayId: 'crear-tu-empresa',
  operaciones: [
    {
      id: 'datos-de-tu-empresa',
      titulo: 'Registrar los datos de tu empresa',
      como: 'En el paso 1 («Su empresa») escribe el NIT, el nombre, elige tu «Actividad económica (CIIU)» en el buscador y la «Clase de riesgo» que te muestra, y el número de trabajadores.',
      porQueImporta:
        'El CIIU y la clase de riesgo determinan qué capítulo de la Resolución 0312/2019 te exige Kairos desde el primer momento — es la base de toda tu autoevaluación.',
    },
    {
      id: 'elegir-modalidad-sg-sst',
      titulo: 'Elegir quién manejará tu SG-SST',
      como: 'En el paso 2 («¿Quién manejará su SG-SST?») eliges entre «Tengo mi responsable», «Quiero un consultor externo» o «Quiero que Kairos lo maneje» (recomendada).',
      porQueImporta:
        'Kairos te guía distinto según quién opere tu sistema — la elección enruta el onboarding, y puedes cambiarla después.',
    },
    {
      id: 'identificar-representante-legal',
      titulo: 'Identificar a tu representante legal',
      como: 'En el paso 3 («Representante legal», el último) escribe la cédula: si ya tiene una cuenta con contraseña, inicias sesión ahí mismo (con tu contraseña o con Google) sin volver a diligenciar tus datos; si es nueva, completas nombre, apellido, correo y contraseña, y confirmas con «Crear empresa y empezar». Si esa cédula ya existe en Kairos pero todavía no has entrado nunca — porque otra empresa te creó la cuenta y no la has reclamado —, el registro no te deja ponerle contraseña aquí: primero abres tu cuenta con el enlace de invitación que te envió esa empresa, y ya con sesión iniciada creas la tuya.',
      porQueImporta:
        'Kairos evita duplicar identidades — una misma cédula nunca crea una cuenta nueva si ya existe una — y ese mismo cuidado es el que impide que un tercero que se sepa tu cédula le ponga contraseña a tu cuenta desde un formulario público: la contraseña de una cuenta que ya existe solo se define probando que la identidad es tuya. El representante legal es quien firma la responsabilidad legal del SG-SST ante la ley; tu empresa queda creada en el plan gratuito y aterrizas directo en tu autoevaluación 0312, viendo tu exposición a multas desde el primer minuto, sin pagar nada todavía.',
    },
  ],
}
